import React from 'react';
import { BellFilled } from '@ant-design/icons';
import { Popover, List, Button } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { selectNotifications } from '../../modules/user/notifications/selectors';
import { notificationsocket } from '../../App';
import { updateListNotification } from '../../modules/user/notifications/actions';
import { formatDate } from '../../helpers';
import { useHistory } from 'react-router';

interface NotificationProps {
    placement?: TooltipPlacement;
}

export const Notification: React.FC<NotificationProps> = ({ placement = 'bottom' }: NotificationProps) => {
    const notificationsData = useSelector(selectNotifications);
    const dispatch = useDispatch();
    const history = useHistory();

    // Map notificationsData to get only the necessary fields for List items
    const notifications = notificationsData?.slice(0, 5);

    // Check if there are unread notifications
    const unreadNotifications = notifications?.filter((notification) => notification.status === 0);

    const handleReadNotification = (event: any, id: string, status: number) => {
        if (status === 0) {
            event.currentTarget.style.backgroundColor = 'transparent';
            if (notificationsocket) {
                notificationsocket.send(JSON.stringify({ type: 'readNotification', id }));
                dispatch(updateListNotification(id));
            }
        }
    };

    const content = (
        <div>
            <List
                size="small"
                dataSource={notifications} // Now using the updated notifications array
                renderItem={(item) => (
                    <List.Item
                        key={item.id}
                        style={{
                            color: item.status === 0 ? 'var(--primary-text-color-main)' : 'var(--text-gray-color)',
                            fontWeight: item.status === 0 ? 'bold' : 'normal', // Bold for unread
                            transition: 'background-color 0.3s', // Smooth transition effect
                            cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => handleReadNotification(e, item.id, item.status)}
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor = item.status === 0 ? '#f0f0f0' : 'transparent')
                        } // Reset on mouse leave
                    >
                        {item.message}
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                            <p
                                style={{
                                    textAlign: 'right',
                                    fontSize: '12px',
                                    fontWeight: 'normal',
                                    marginRight: '4px',
                                }}></p>

                            <p style={{ textAlign: 'right', fontSize: '12px', fontWeight: 'normal' }}>
                                {formatDate(item.createdAt)}
                            </p>
                        </div>
                    </List.Item>
                )}
            />
            <Button type="link" block onClick={() => history.push('/profile/notifications')}>
                View All
            </Button>
        </div>
    );

    return (
        <Popover placement={placement} content={content} title="Notifications" trigger="hover">
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <BellFilled style={{ fontSize: '20px', cursor: 'pointer' }} />
                {unreadNotifications?.length > 0 && (
                    <div
                        style={{
                            position: 'absolute',
                            top: '-4px',
                            right: '-4px',
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: 'red',
                        }}
                    />
                )}
            </div>
        </Popover>
    );
};
